<template>
  <div>
    <Breadcrumbs title="Compatibility" main="Catalog"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="col-md-12">
                <form @submit.prevent="checkCompatibility">
                  <div class="form-group">
                    <label class="form-label">VIN</label>
                    <input placeholder="WBAJB1C56KB366511" class="form-control" v-model="vin">
                  </div>
                  <div class="form-group">
                    <label class="form-label">Part number</label>
                    <input placeholder="07119919039" class="form-control" v-model="partNumber">
                  </div>
                  <div class="form-footer" style="text-align: center">
                    <button type="submit" class="btn btn-primary" :disabled="!vin || !partNumber">Check</button>
                    <div @click="clearForm" class="btn btn-light ml-2">Clear</div>
                  </div>
                </form>
              </div>

              <div class="col-md-12" v-if="loadingProcess" style="text-align: center;margin-top: 30px;">
                <div class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>

              <div class="col-md-12" v-if="!loadingProcess && compatible !== null" style="text-align: center;margin-top: 30px;">
                <div class="compatible" v-if="compatible">Compatible</div>
                <div class="compatible not-compatible" v-if="!compatible">Not Compatible</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.compatible {
  padding: 10px;
  border: 1px solid green;
  background-color: #8cff8c;
  text-align: center;
  display: inline-block;
}

.not-compatible {
  border: 1px solid red;
  background-color: #ff8c8c;
}
</style>

<script>
import {compatibilityService} from '../../_services';

export default {
  data: function () {
    return {
      loadingProcess: false,
      vin: null,
      partNumber: null,
      compatible: null
    };
  },
  methods: {
    clearForm() {
      this.vin = null;
      this.partNumber = null;
      this.compatible = null;
    },
    checkCompatibility() {
      this.loadingProcess = true;

      compatibilityService.checkCompatibility(
          this.vin,
          this.partNumber
      )
          .then(
              async response => {
                this.loadingProcess = false;
                this.compatible = response.data.compatible === true;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
                this.loadingProcess = false;
                this.compatible = null;
              }
          );
    },
  },
}
</script>
